import {
  AlertArea,
  FormField,
  Spinner,
} from '@codev/helix-react';
import PropTypes from 'prop-types';
import React from 'react';
import {
  FormControl,
} from 'react-bootstrap';
import ResendCodeLink from './ResendCodeLink.jsx';
import styles from './View.css';
import translations from './translations.js';

const View = ({
  alertChannel,
  centered,
  code,
  language = 'en_US',
  loading,
  onChange,
  onResendCode,
  scheme,
  style,
  ...rest
}) => {
  let centeredStyles = {};
  let centeredInputStyles = {};

  if (centered) {
    centeredStyles = {
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column',
      textAlign: 'center',
    };
    centeredInputStyles = {
      marginLeft: 'auto',
      marginRight: 'auto',
    };
  }

  return (
    <div
      {...rest}
      style={{
        fontSize: '16px',
        ...centeredStyles,
        ...style
      }}
    >
      <AlertArea channels={alertChannel} />
      {
        loading &&
      <div
        style={{
          textAlign: 'center',
        }}
      >
        <Spinner
          className="warning"
          style={{
            height: '3em',
            width: '3em',
          }}
        />
      </div>
      }
      {
        !loading &&
      <div
        style={{
          marginBottom: '20px',
        }}
      >
        {translations('stepText', language)}
      </div>
      }
      {
        !loading &&
      <div
        style={centeredInputStyles}
      >
        <FormField
          className={styles.input}
          isRequired
          isRequiredErrorMessage={translations('isRequiredMessage', language)}
          value={code}
          style={{
            width: '225px',
            padding: 0,
            marginBottom: '20px',
          }}
        >
          <FormControl
            autoFocus
            onChange={(event) => onChange(event.target.value)}
            type="text"
            value={code}
          />
        </FormField>
      </div>
      }
      {
        !loading &&
      <div>
        <ResendCodeLink
          language={language}
          onClick={onResendCode}
        />
      </div>
      }
    </div>
  );
};

View.propTypes = {
  alertChannel: PropTypes.string,
  centered: PropTypes.bool,
  code: PropTypes.string.isRequired,
  language: PropTypes.string,
  loading: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onResendCode: PropTypes.func.isRequired,
  scheme: PropTypes.object.isRequired,
  style: PropTypes.object,
};

export default View;
